import React from 'react';
import LeadPreviewSection from '../components/atoms/LeadPreviewSection';

const LeadPreview = () => {
  return <LeadPreviewSection />;
};

export default LeadPreview;
